<template>
    <div>
        <span class="label published" v-if="internalValue == 1"><i class="icon icon-check"></i></span>
        <span class="label unpublished" v-if="internalValue == 0"><i class="icon icon-icon_close"></i></span>
    </div>
</template>

<script>
    export default {
        name: 'Checked',
        props: ['value','label','name','placeholder'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Checked.vue